import { MIN_ROW_HEAD_WIDTH } from '@/components/property-compare/constants';
import { Property } from '@/types';
import clsx from 'clsx';
import Image from 'next/image';
import { ReactNode } from 'react';

interface CompareLineProps {
  hideIfEqual?: boolean;
  masterPropertyNumber?: string;
  label: string | ReactNode;
  properties: Property[];
}

export function AmenityComparisionLine(props: CompareLineProps) {
  const amenitiesSet = new Set<string>(
    Array.prototype.concat.apply(
      [],
      props.properties.map((x) => x.nearByAmenties)
    )
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const amenties = [...(amenitiesSet as any)].map((x) => ({
    key: x,
    values: [],
  }));

  amenties.forEach((x) => {
    props.properties.forEach((y) => {
      x.values.push(y.nearByAmenties.includes(x.key));
    });
  });

  return (
    <>
      <tr>
        <td
          style={{ minWidth: MIN_ROW_HEAD_WIDTH }}
          className="text-center border border-gray-300"
        >
          {props.label}
        </td>
        {props.properties.map((property, index) => (
          <td
            key={index}
            className={clsx(
              'text-center border border-gray-300',
              props.masterPropertyNumber === property.propertyNumber &&
                'bg-gray-50'
            )}
          >
            {property.nearByAmenties.join(', ')}
          </td>
        ))}
      </tr>
      {amenties.map((x, index) => (
        <tr key={index}>
          <td
            style={{ minWidth: MIN_ROW_HEAD_WIDTH }}
            className="px-2 text-left border border-gray-300 italic text-sm text-gray-600"
          >
            {x.key}
          </td>
          {x.values.map((value, index) => (
            <td
              key={index}
              className={clsx(
                'text-center border border-gray-300',
                props.properties[index].propertyNumber ===
                  props.masterPropertyNumber && 'bg-gray-50'
              )}
            >
              {value ? (
                <Image
                  alt="checked"
                  src="/img/checked.png"
                  width={12}
                  height={12}
                />
              ) : null}
            </td>
          ))}
        </tr>
      ))}
    </>
  );
  // if (
  //   props.hideIfEqual &&
  //   props.properties.every(
  //     (property) =>
  //       props.valueExtractor(property) ===
  //       props.valueExtractor(props.properties[0])
  //   )
  // ) {
  //   return null;
  // }

  // return (
  //   <tr>
  //     <RowHeader label={props.label} />
  //     {props.properties.map((property) => (
  //       <td
  //         style={{ minWidth: MIN_WIDTH }}
  //         key={property.propertyNumber}
  //         className={clsx('border border-gray-300')}
  //       >
  //         {props.render(
  //           props.valueExtractor ? props.valueExtractor(property) : null,
  //           props.comparator ? props.comparator(props.properties, property) : 0,
  //           property,
  //           props.properties
  //         )}
  //       </td>
  //     ))}
  //   </tr>
  // );
}
